import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（终端名：computer_name，绑定IP：bind_ip，操作系统：system_name，登录状态：login_status，开放端口数：port_total，阻断规则数：rule_total，分组名：group_name） */
  sort?: string
  /** 搜索关键词 */
  key_word: string
  range: number
  system_type: number
  permission_name?: string
}

export interface TerminalItem {
  /** 设备id */
  device_id: string
  /** 计算机名称 */
  computer_name: string
  /** 分组名 */
  group_name: string
  /** 内网IP地址 */
  system_ip: string
  /** 外网IP地址 */
  client_ip: string
  /** 操作系统名 */
  system_name: string
  /** 登录状态,1->在线，2->离线 */
  login_status: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  /** 开放端口总数 */
  port_count: string
  /** 阻断规则总数 */
  rule_count: string
  /** 风险端口数 */
  risk_count?: string
  /** 未知端口数 */
  unknown_count?: string
  user_mark: string // 登记用户名
  /** 授权状态：0-正常，1-待授权 2-未订阅 */
  auth_status?: number
}
export interface PortQueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 终端id */
  device_id: string
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（端口号：port_num，协议：protocol，绑定IP：bind_ip，监听的进程名：process_name） */
  sort?: string
}

export interface TerPortItem {
  /** 端口号 */
  port_num: number
  /** 协议 */
  protocol: string
  /** 监听的进程名 */
  process_name: string
  /** 绑定IP */
  bind_ip?: string
  /** 终端数量 */
  device_total?: number
  /** 风险参考（是否已知：0->未知，1->已知） */
  is_known_risk?: number
  /** 风险参考（详情说明） */
  risk_detail?: string
  /** 系统类型 1-windows 2-linux 3-win server */
  system_type: number
}

export interface DeviceBlockedRuleQueryParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 终端设备id */
  device_id: string
  /** 排序类型,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段，默认是device_count */
  sort?: string
}

export interface DeviceBlockedRuleItem {
  /** 阻断规则id */
  rule_id: number
  /** 阻断端口起点 */
  port_start: number
  /** 阻断端口终点 */
  port_end: number
  /** 端口规则 */
  port_protocol: string
  /** 系统类型 1-windows 2-linux 3-win server */
  system_type: number
}

@Injectable()
export class TerminalViewService {
  constructor (private http: Http) {
  }
  @ParamsClean()
  @InvokeThrottle()
  getTerminalList (data: QueryParams) {
    return this.http.post<{
      /** 终端列表 */
      list: TerminalItem[]
      /** 总数 */
      total: number
      enable_total: number
    }>('/portcontrol/device/list', data)
  }

  @ParamsClean()
  @InvokeThrottle()
  getTerminalPorts (data: PortQueryParams) {
    return this.http.post<{
      /** 端口列表 */
      list: TerPortItem[]
      /** 总数 */
      total: number
    }>('/portcontrol/device-port/list', data)
  }

  @ParamsClean()
  @InvokeThrottle()
  getPortcontrolDeviceBlockedRuleList (data: DeviceBlockedRuleQueryParams) {
    return this.http.post<{
      /** 端口列表 */
      list: DeviceBlockedRuleItem[]
      /** 总数 */
      total: number
    }>('/portcontrol/device-blocked-rule/list', data)
  }
}
